module.exports = __webpack_public_path__ + "static/media/DeLink.5b832f7e.svg";